export function convertPlayerTimeToFormattedTimeCode (playerTime) {
  playerTime = Math.max(playerTime, 0);
  var t = Math.floor(playerTime / 3600), n = Math.floor(playerTime % 3600 / 60), r = Math.floor(playerTime % 3600 % 60);
  return (0 === t ? "" : t < 10 ? "0" + t.toString() + ":" : t.toString() + ":") + (n < 10 ? "0" + n.toString() : n.toString()) + ":" + (r < 10 ? "0" + r.toString() : r.toString())
}
